import React from 'react'
import './womenpage.scss'
import { StaticImage } from 'gatsby-plugin-image'

import styled from 'styled-components'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from 'swiper';

import "swiper/css";
import { Pagination } from "swiper";
import "swiper/css/pagination";
import Reviews from '../reviews/Reviews'
import Services from '../services/Services'
import Footer from '../footer/footer'
import SlideShowW from '../slide/SlideShowW'
const Screen = styled.div`
max-width: 1920px;
background: #d1bbff;
max-height: 500px;
height: 100%;
width:100%;
div{
  height: 400px;
  @media screen and (max-width:456px)
  {
    height: 311px;
  }
}

`
const TextArea = styled.div`
flex: 1;
background: linear-gradient(143deg,#fff2e0 4.4%,#edb1b1 97.41%);

div {
  top: 15%;
  position: relative;
  width: 80%;
  transform: translate(50px, 0px);
  h1{
    font-size: 3rem;
    letter-spacing: 10px;
  }
  p{
    font-size: 25px;
    font-weight:100;
  }
  button{
    padding: 0.2rem 2.5rem;
    background: #ffffff;
    color: black;
    font-size: 20px;
    margin: 1rem 0;
  }
}

`
const Grid = styled.div`
display:grid;
grid-template-columns: repeat(2, 1fr);
span{
  display: flex;
  font-size: 20px;
  align-items: center;
  cursor:pointer;
  width: fit-content;
  svg{
    margin:0 10px ;
  }
}
`
const Sweaters = styled.div`
font-size: 2rem;
    font-weight: bold;
    z-index: 1;
    position: absolute;
    margin: 0 0.3rem;
    text-align: center;
    top: 7%;
`


const Shoes = styled.div`
font-size: 2rem;
    font-weight: bold;
    z-index: 1;
    position: absolute;
    margin: 0 0.3rem;
    text-align: center;
    top: 15%;
`
const Hats = styled.div`
font-size: 2rem;
    font-weight: bold;
    z-index: 1;
    color: white;
    position: absolute;
    margin: 0 0.3rem;
    text-align: center;
    top: 20%;
`
const Jackets = styled.div`
font-size: 2rem;
    font-weight: bold;
    z-index: 1;
    color: white;
    position: absolute;
    margin: 0 0.3rem;
    text-align: center;
    top: 5%;
`

const WomenPage = () => {
  SwiperCore.use([Autoplay]);
  return (
    <div className='w-full womenpage'>
    <div className='marque-container'>

        <div className='marquee '>
            <div>
                <span>STRONG. DURABLE. BUILT TO LAST.</span>
                <span>STRONG. DURABLE. BUILT TO LAST.</span>
            </div>

        </div>
    </div>
        <div className='slide-screen'>
              <div className='flex slide-menu'>
                  <div className='  flex-test'>
                        <div className='womenslidee'>
                           {/* <Carousel autoplay  slides={slides}  /> */}
                           <Swiper

        direction={"vertical"}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className="mySwiper"
        autoplay
      >
  <SwiperSlide>
                           <Jackets className='flex'>
    J<br />A<br />C<br />K<br />E<br />T<br />S
  </Jackets>
 <StaticImage loading='eager'  src='https://images.unsplash.com/photo-1624124959947-5fa0f8886507?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=435&q=80' style={{height:'80vh'}} alt='shirt' className='w-full'/>
  </SwiperSlide>
  <SwiperSlide>
                           <Hats className='flex'>
    H<br />A<br />T<br />S<br />
  </Hats>
<StaticImage loading='eager'  src='../../images/jeans.jpg' style={{height:'63vh'}} alt='jeans' className='w-full'/>
  </SwiperSlide>

  <SwiperSlide>
                           <Shoes className='flex'>
    S<br />H<br />O<br />E<br />S<br />
  </Shoes>
<StaticImage loading='eager' src='https://images.unsplash.com/photo-1515555230216-82228b88ea98?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format' style={{height:'63vh'}} alt='shoes' className='w-full' />
  </SwiperSlide>
  <SwiperSlide>
                           <Sweaters className='flex'>
    S<br />W<br />E<br />A<br />T<br />E<br />R<br />S
  </Sweaters>
<StaticImage loading='eager' src='../../images/girll.jpg' style={{height:'63vh'}}  alt='girl' className='w-full' />
  </SwiperSlide>
  <SwiperSlide>
                           <Sweaters className='flex'>
    S<br />W<br />E<br />A<br />T<br />E<br />R<br />S
  </Sweaters>
<StaticImage loading='eager' src='https://images.unsplash.com/photo-1610705267928-1b9f2fa7f1c5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format'  style={{height:'70vh'}} alt='shampoo' className='w-full' />
  </SwiperSlide>
  <SwiperSlide>
                           <Sweaters className='flex'>
    S<br />W<br />E<br />A<br />T<br />E<br />R<br />S
  </Sweaters>
<StaticImage loading='eager' src='../../images/cream.jpg' style={{height:'70vh'}} alt='cream' className='w-full' />
  </SwiperSlide>
  <SwiperSlide>
                           <Sweaters className='flex'>
    S<br />W<br />E<br />A<br />T<br />E<br />R<br />S
  </Sweaters>
<StaticImage loading='eager' src='../../images/idk.jpg' style={{height:'111vh'}} alt='something'  className='w-full' />
  </SwiperSlide>
  <SwiperSlide>
                           <Sweaters className='flex'>
    S<br />W<br />E<br />A<br />T<br />E<br />R<br />S
  </Sweaters>
<StaticImage loading='eager' src='../../images/perfumegirl.jpg' alt='perfume' style={{height:'65vh'}}  className='w-full' />
  </SwiperSlide>
  </Swiper>
                      </div>
                  </div>
            <TextArea className='lumine-text'>
                <div>
                  <h1>LUMINE</h1>
                      <p>
                    Discover what suits you with Lumine.
                    Your unique style and fashion is waiting for you.
                      </p>
                <button>SHOP NOW</button>
              </div>
            </TextArea>
        </div>
        </div>
        <main>
          <div className='text-center  mt-16'>
          <h1 className='text-l'>Make your own fashion</h1>
          <p className='font-thin text-p'>Lumine is an E-commerce website,it only purpose is<br/> to provide a unique style for your very fashion.<br/>Start glowing with Lumine.</p>
            </div>
            {/* <SlideMen/> */}
            <div className='mt-16'>
            <SlideShowW />
            </div>
            <div className='mt-16 text-center'>
<h1 className='text-l'>Best sells & New Products</h1>
<p className='text-p font-thin'>Discover new items,products and more with LUMINE !<br/>Glow up with LUMINE.</p>
            </div>
            <div className='items mt-16'>
            {/* <Items /> */}
            </div>
{/* Quote1 */}
<Screen className=' text-center mt-16'>
  <Grid>
<div className='text text-dark pl-12 pt-24 pr-12 pb-12 text-dark quote'>
<h1 className='font-item'>"Fashion is very important. It is life-enhancing and, like everything that gives pleasure, it is worth doing well.”</h1>
<span>Discover Now<svg className='next-btn' width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
</span>
</div>
<div className='bg'>
  </div>
</Grid>
</Screen>
{/*Quote 2 */}    
<Screen className='qt-2 text-center border-t-2 border-black'>
  <Grid>
  <div className='bg-1'>
  </div>
<div className='text text-dark pl-12 pt-24 pr-12 pb-12 text-dark quote'>
<h1 className='font-item'>"Fashion is very important. It is life-enhancing and, like everything that gives pleasure, it is worth doing well.”</h1>
<span>Discover Now<svg className='next-btn' width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
</span>
</div>

</Grid>
</Screen>
{/*Quote 3 */}    
<Screen className='qt-3 text-center border-t-2 border-black'>
  <Grid>
 
<div className='text text-dark pl-12 pt-24 pr-12 pb-12 text-dark quote'>
<h1 className='font-item'>"Fashion is very important. It is life-enhancing and, like everything that gives pleasure, it is worth doing well.”</h1>
<span>Discover Now<svg className='next-btn' width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
</span>
</div>
<div className='bg-3'>
  </div>
</Grid>
</Screen>
<div className='w-full marqueee2 '>
    <div className='marque-container2'>

        <div className='marquee2 '>
            <div>
                <span>STRONG. DURABLE. BUILT TO LAST.</span>
                <span>STRONG. DURABLE. BUILT TO LAST.</span>
            </div>

        </div>
    </div>
    </div>
    <Reviews />
    <div>
      <h1 className='text-center text-three uppercase'>
        Services provided for you 
      </h1>
    <Services />
    </div>
        </main>
        <Footer />
</div>
  )
}

export default WomenPage
